const UnderlyingSpan = ({ className }) => {
    return (
        <span
            className={`absolute bottom-0 left-1/2 w-0 h-0.5 transition-all duration-300 group-hover:w-full group-hover:left-0 ${className}`}
        />
    );
};

export default UnderlyingSpan;
